import formQuestionsToFormWithTree from '@opsbase/lib-form/convert/formQuestionsToFormWithTree';
import isAnswerableQuestion from '@opsbase/lib-form/helpers/isAnswerableQuestion';
import i18n from '@opsbase/lib-i18n';
import useCss from '@opsbase/web-css';
import Card from '@opsbase/web-layout/Card';
import Text from '@opsbase/web-ui/Text';
import React, { useMemo } from 'react';
import { makeSectionClasses } from '../OpDefinitionEditOverviewTab';
export function QuestionCountOverviewSection(props) {
    const { opDefinition, className } = props;
    const form = opDefinition.form;
    const myCss = useCss(makeSectionClasses);
    const noOfQuestions = useMemo(() => Object.values(formQuestionsToFormWithTree(form).questions).filter(q => isAnswerableQuestion(q)).length, [form]);
    return (React.createElement(Card, { classes: { root: className } },
        React.createElement(Text, { variant: "h3", tip: i18n.t('answerable-only') }, i18n.t('no-of-questions')),
        React.createElement(Text, { className: myCss.massiveText }, noOfQuestions)));
}
export default QuestionCountOverviewSection;
